import {
  ENotificationAction,
  NotificationAction,
} from "../actions/NotificationAction";
import { RootState } from "./RootReducer";
import { ENotificationType } from "../../Model/ENotificationType";
import { ReactNode } from "react";

interface Notification {
  type: ENotificationType;
  message?: string;
}

export interface ToastReduxState {
  open: boolean;
  message: ReactNode;
  variant: "success" | "warning" | "error";
  duration: number;
}

interface State {
  notifications: Notification[];
  toast: ToastReduxState;
}

const initialState: State = {
  notifications: [],
  toast: {
    open: false,
    message: "",
    variant: "success",
    duration: 2000,
  },
};

export function notificationsReducer(
  state = initialState,
  action: NotificationAction
): State {
  switch (action.type) {
    case ENotificationAction.SEND_NOTIFICATION: {
      if (action.notification == null) {
        throw new Error("Notification is null");
      }
      return {
        ...state,
        notifications: [...state.notifications, action.notification],
      };
    }
    case ENotificationAction.REMOVE_NOTIFICATION: {
      const notifications = [...state.notifications];
      notifications.splice(0, 1);
      return { ...state, notifications: notifications };
    }
    case ENotificationAction.SET_TOAST: {
      return { ...state, toast: action.toast! };
    }
    default:
      return state;
  }
}

export const getNotifications = (state: RootState) =>
  state.notificationsStore.notifications;

export const selectToast = (state: RootState) => state.notificationsStore.toast;
